import React, { Component } from 'react';
import LoginForm from './LoginForm';

import './LoginPage.css';

import logo from '../../byne.png';

class LoginPage extends Component {
  render() {
    return (
      <div className="LoginPage">
        <img
          src={logo}
          height="30"
          className="align-top mx-auto d-block mb-5"
          alt="BYNE"
        />
        <LoginForm />
      </div>
    );
  }
}

export default LoginPage;
